var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-gutters align-items-center" }, [
    _c("div", { staticClass: "col-auto" }, [
      _vm.allowOrder
        ? _c("span", { staticClass: "sortable-handle cursor-move mr-2" }, [
            _c("i", {
              staticClass: "fa fa-bars text-light-gray bold",
              staticStyle: { "margin-bottom": "0.8rem" },
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col" }, [_vm._t("custom-field")], 2),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-auto d-flex flex-row justify-content-between" },
      [
        _vm.allowVisibility
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: { title: _vm.visibilityTooltipText },
                    expression: "{ title: visibilityTooltipText }",
                  },
                ],
                ref: "visibilityTooltip",
                staticClass: "clickable ml-2",
                on: { click: _vm.handleVisibility },
              },
              [
                _c("custom-field-visibility-icon", {
                  attrs: { "visibility-type": _vm.visibilityType },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowEdit
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: { title: _vm.$t("global.words.edit") },
                    expression: "{ title: $t('global.words.edit') }",
                  },
                ],
                staticClass: "clickable ml-2 text-capitalize",
                on: { click: _vm.handleEditClick },
              },
              [
                _c("i", {
                  staticClass: "fa fa-pencil text-primary",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowDelete
          ? _c(
              "inline-prompt",
              {
                attrs: { "confirmation-text": _vm.deleteConfirmation },
                on: { accept: _vm.handleDeleteClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "preConfirmationContent",
                      fn: function () {
                        return [_vm._t("delete-confirmation")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: { title: _vm.$t("global.words.delete") },
                        expression: "{ title: $t('global.words.delete') }",
                      },
                    ],
                    staticClass: "clickable ml-2",
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash text-danger",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }